/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m23.7708 5.958-.7533.7532a.7805.7805 0 0 1-.3121.193l-1.8816.6275-.6265 1.8806a.8043.8043 0 0 1-.5052.506l-1.8826.6265-.6265 1.8817a.8056.8056 0 0 1-.1926.3123l-1.3191 1.3191.1885.1885a3.9936 3.9936 0 0 1 0 5.6469l-3.5362 3.94a4 4 0 0 1-5.647 0L1.173 18.3857a3.9938 3.9938 0 0 1 0-5.6471L4.945 8.9702a4.0003 4.0003 0 0 1 5.647 0l.1886.1885 8.0229-7.9283a.7854.7854 0 0 1 .6532-.2292L23.2888 1a.7988.7988 0 0 1 .4744.2303.7984.7984 0 0 1 .2269.4759L24 5.3048a.7996.7996 0 0 1-.2292.6532ZM8.2374 14.1768c-.6834-.6834-1.7914-.6834-2.4748 0l-.5858.5858c-.6834.6834-.6834 1.7914 0 2.4748l2.5858 2.5858c.6834.6834 1.7914.6834 2.4748 0l.5858-.5858c.6834-.6834.6834-1.7914 0-2.4748l-2.5858-2.5858Z"
    clipRule="evenodd"
  />,
  'MenuOnPremKeysFilled'
);
